// -- React Libraries
import React, { Component } from 'react';
import createClass from 'create-react-class';
import { connect } from 'react-redux';
import appActions from '../../redux/app/actions';
const { appSelected, searchTermUpdated } = appActions;
import { bindActionCreators } from 'redux';
import { Panel, ControlLabel, Glyphicon } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactJson from 'react-json-view';
// import SearchIcon from '../../image/search.png';
// import ReactFlagsSelect from 'react-flags-select';
//import Select from 'react-select';

// -- Libraries
import axios from 'axios';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

// -- Variables
import API_URL from './../../constants/server';

// -- Components
import Header from "../../components/Headers/index";
import HeaderLogo from "../../components/Headers/Logo";
import HeaderMenu from "../../components/Headers/Menu";
import HeaderFillRow from "../../components/Headers/FillRow";
import SearchApp from "../../components/SearchAppBar/index";
import Footer from "../../components/Footer/index";

import CampaignsHolder from "./CampaignsHolder/index";

// -- Styles
import CampaignListWrapper from './style';
import basicStyle from '../../config/basicStyle';

// -- Resources
import GreenUpArrow from '../../image/arrow_green.png';
import RedDownArrow from '../../image/arrow red.png';
import GreenDownArrow from '../../image/arrow_green.1.png';
import RedUpArrow from '../../image/arrow red.1.png';
import RunningIcon from '../../image/running.png';
import PauseIcon from '../../image/pause.png';

const GravatarOption = createClass({
	propTypes: {
		children: PropTypes.node,
		className: PropTypes.string,
		isDisabled: PropTypes.bool,
		isFocused: PropTypes.bool,
		isSelected: PropTypes.bool,
		onFocus: PropTypes.func,
		onSelect: PropTypes.func,
		option: PropTypes.object.isRequired,
	},
	handleMouseDown (event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},
	handleMouseEnter (event) {
		this.props.onFocus(this.props.option, event);
	},
	handleMouseMove (event) {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
	},
	render () {
		let gravatarStyle = {
			borderRadius: 3,
			display: 'inline-block',
			marginRight: 10,
			position: 'relative',
			top: -2,
      verticalAlign: 'middle',
      width: '40px',
      height: '40px'
    };
    let logoStyle = {
      width: '56px',
      height: '56px'
    };
		return (
			<div className={this.props.className}
				onMouseDown={this.handleMouseDown}
				onMouseEnter={this.handleMouseEnter}
				onMouseMove={this.handleMouseMove}
				title={this.props.option.title}>
        <img
            style={gravatarStyle}
            src={this.props.option.options.artworkUrl60}
        />
				<span className="span">
          {this.props.children}
        </span>
			</div>
		);
	}
});

class CampaignList extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      updated: false,
      campaignList: null,
      redirectToReferrer: false,
      optionList : null,
      globalCampaignList : []
    }
    this.onStatusChanged.bind(this);
  }

  onStatusChanged = async (pCid, dCid, status) => {
    // 'ENABLED' : 'PAUSED'
    console.log('on onStatusChanged click , ', pCid, dCid, status);

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    const cidList = [pCid, dCid];
    const request = {
      campaign: {
        status: status,
      }
      // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
    }
    const cidResults = await Promise.all(cidList.map( async (cid) => {
      
      let requestResponse;
      try {
        requestResponse = await axios.post(`${API_URL}/user/campaigns/cid/${cid}`, request, { headers } )

        const updatedCampaign = requestResponse.data.response.data;
        console.log( '[campaigns update] ', cid,  updatedCampaign); 

        const index = this.state.globalCampaignList.findIndex( item => {
          return item.pCid === pCid;
        })

        /**
         * TODO show pop up for no chnage
         * servingStateReason = updatedCampaign.servingStateReasons[0]
         */
        //
        const items = Object.assign(this.state.globalCampaignList); // Pull the entire items object out. Using object.assign is a good idea for objects.
        if(items[index].servingStatus !== updatedCampaign.servingStatus){
          items[index].servingStatus = updatedCampaign.servingStatus; // update the items object as needed
          this.setState({ globalCampaignList: items }); // Pu
        }
        
      } catch (error) {
        console.log( '[campaigns update] ', cid, error); 
      }

      return requestResponse;
    }));
  }
  /**
   * to be deprecated
   */
  onSelectFlag = (countryCode) => {
    this.props.onCountryCodeUpdated(countryCode);
  }
  onChange = (app) => {
		this.setState({
			value: app,
    });


    const { optionList, input } = this.state;
    if ( optionList && optionList.length > 1){
      this.props.appSelected(app.value , optionList[1].value);
    } else if ( optionList && optionList.length === 1){
      this.props.appSelected(app.value , app.value);
    } else {
      this.props.appSelected(app.value , null);    
    }
    this.props.searchTermUpdated(input);

    if ( this.props.auth.isAuthenticated() ){
      this.props.history.push(`/addCampaign/appId/${app.value.adamId}`);
    } else {
      this.props.history.pus('/home')
    }
  };

  getApps = (input) => {
		if (!input) {
			return Promise.resolve({ options: [] });
		}
    this.setState({ input })
    return axios.post(`https://itunes.apple.com/search`, {},
     { params: { term: input, country: this.props.countryCode, entity: 'software'}})
      .then( (response) => {
        if(response.data != undefined){
          let itemData = response.data.results;
          let items = itemData.map( (item, i) => 
            { 
              return { 
                key: i,
                label: item.trackCensoredName,
                id: i, 
                value: { 
                  adamId: item.trackId,
                  artworkUrl60: item.artworkUrl60,
                  artworkUrl100: item.artworkUrl100,
                  name: item.trackCensoredName,
                  trackCensoredName: item.trackCensoredName,
                  sellerName: item.sellerName,
                  screenshotUrls: item.screenshotUrls,
                  bundleId: item.bundleId
                },
                options: item
              } 
            }
          )
          console.log( ' items ' , items );
          
          this.setState({ optionList: items })
          return { options: items };          
        }
      })
      .catch(error => {
        console.log( error.message)
      });  
		// return fetch(`https://api.github.com/search/users?q=${input}`)
		// .then((response) => response.json())
		// .then((json) => {
		// 	return { options: json.items };
		// });
  };

  
  /**
   * to be redux saga 
   * @param {*} appId 
   * @param {*} country 
   */
  async getItunesStoreData( appId, country ){
    const API_PUBLIC_SEARCH =  'https://itunes.apple.com/lookup';
    console.log( '[getItunesStoreData] ', 'prepare'); // error is not defined

    let results= [];
    try {
      const { getAccessToken } = this.props.auth;
      const response = await axios.post(API_PUBLIC_SEARCH, {}, { params: { id : appId, 'Authorization': `Bearer ${getAccessToken()}`, country } });
      
      console.log( '[getItunesStoreData] ', response.data.results); // error is not defined
      results = response.data.results;
    } catch (error) {
      console.log( '[getItunesStoreData] ', error); // error is not defined
    }
    

    if ( results.length > 0){
      return results[0];
    } else {
      return null;
    }
    console.log(this.state.itunesLookUp);
  }

  

  async componentWillMount() {
    
    const { userProfile, getProfile, getProfileFake } = this.props.auth;

    if ( process.env.REACT_APP_STAGE === 'fake'){
      this.setState({ profile : getProfileFake() });
    } else {
      if (!userProfile) {
        getProfile((err, profile) => {
          this.setState({ profile });
        });
      } else {
        this.setState({ profile: userProfile });
      }
    }


    const app1 = {"adamId":331177714,"artworkUrl60":"http://is5.mzstatic.com/image/thumb/Purple62/v4/7a/df/45/7adf4578-c3aa-7d77-859a-1777707c04ca/source/60x60bb.jpg","artworkUrl100":"http://is5.mzstatic.com/image/thumb/Purple62/v4/7a/df/45/7adf4578-c3aa-7d77-859a-1777707c04ca/source/100x100bb.jpg","name":"Starbucks","trackCensoredName":"Starbucks","sellerName":"Starbucks Coffee Company","screenshotUrls":["http://is1.mzstatic.com/image/thumb/Purple128/v4/50/78/96/50789699-c577-e6de-69d4-9da2a447957f/source/392x696bb.jpg","http://is5.mzstatic.com/image/thumb/Purple128/v4/5e/d2/13/5ed2137c-f924-ab77-e488-b44fb21aeaf4/source/392x696bb.jpg","http://is1.mzstatic.com/image/thumb/Purple128/v4/2c/b4/77/2cb4777b-0324-981b-98ae-b04fe27f7e76/source/392x696bb.jpg","http://is5.mzstatic.com/image/thumb/Purple128/v4/3f/13/db/3f13db32-49b2-b9d6-3d24-edb17246d7ea/source/392x696bb.jpg","http://is5.mzstatic.com/image/thumb/Purple128/v4/91/01/5e/91015e72-8010-db3e-c911-798e28d595c9/source/392x696bb.jpg"]};
    const app2 = {"adamId":424779886,"artworkUrl60":"http://is5.mzstatic.com/image/thumb/Purple128/v4/fb/56/d4/fb56d459-a4f5-213c-bfcf-8de5b55904b5/source/60x60bb.jpg","artworkUrl100":"http://is5.mzstatic.com/image/thumb/Purple128/v4/fb/56/d4/fb56d459-a4f5-213c-bfcf-8de5b55904b5/source/100x100bb.jpg","name":"Secret Menu for Starbucks!","trackCensoredName":"Secret Menu for Starbucks!","sellerName":"Sepia Software LLC","screenshotUrls":["http://is5.mzstatic.com/image/thumb/Purple111/v4/e0/04/67/e0046721-6516-087b-8561-3a3b175c2b1d/source/392x696bb.jpg","http://is4.mzstatic.com/image/thumb/Purple111/v4/1b/fd/de/1bfddef4-4c54-1e8f-8eb3-58f85e4867f6/source/392x696bb.jpg","http://is3.mzstatic.com/image/thumb/Purple122/v4/90/ff/91/90ff9156-25e1-517c-60f9-19bfe266d761/source/392x696bb.jpg"]};
    this.setState({
      app1, app2
    });
    
    if ( process.env.REACT_APP_STAGE === 'fake'){

      this.props.appSelected(app1 , app2);
    }
    

  }

  async componentDidMount(){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}

    let results= [];
    let globalCampaignList = [], campaignList = []

    if ( process.env.REACT_APP_STAGE !== 'fake' ){
      try {
        const response = await axios.get(`${API_URL}/user/campaigns`, { headers } )
        console.log( '[getAccessToken] ', response.data); // error is not defined
        campaignList = response.data;
      } catch (error) {
        console.log( '[getAccessToken] ', error); // error is not defined
      }

      //may need to use promise.all
      await Promise.all(campaignList.forEach( async (appItem) =>  {
        let endDate = moment();//.format('YYYY-MM-DD');      
        let startDate = moment(endDate).subtract(20, 'days');
        console.log( startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
        /**
         * store info
         */
        const storeInfo = null;//await this.getItunesStoreData(appItem.appId); 
  
        //https://medium.com/@antonioval/making-array-iteration-easy-when-using-async-await-6315c3225838
        
        const performanceMap = await Promise.all(appItem.performanceByRegion.map( async (item) => {
          let reportResponse, totalData;
          if ( item.campaignId ){
            try {
              reportResponse = await axios.get(`${API_URL}/user/campaigns/cid/${item.campaignId}/adgroups/rowtotals/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`, { headers } )
              if ( reportResponse.data.response.pagination.totalResults  > 0 ) {
                totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
              }
              // if ( data.reportingDataResponse.row[])
              console.log( '[campaigns adgroups] ', item.campaignId,  reportResponse.data.response); 
            } catch (error) {
              console.log( '[campaigns adgroups] ', item.campaignId, error); 
            }
          }
  
          //get p cid to check status : RUNNING / NOT_RUNNING
          let searchadsCampaign;
          try {
            const response = await axios.get(`${API_URL}/user/campaigns/cid/${item.campaignId}`, { headers } )
            console.log( '[get campagin detail] ', response.data.response.data); // error is not defined
            searchadsCampaign = response.data.response.data;
          } catch (error) {
            console.log( '[get campagin detail]  ', error); // error is not defined
          }
  
          return {
            appId: appItem.appId, //primary id
            region: item.region,
            pCid: item.campaignId,
            pReportAdGroup: reportResponse.data.response,
            pTotalData: totalData,
            emAdGroupId: item.emAdGroupId,      
            key: appItem.appId + item.region,
            storeInfo: storeInfo,
            servingStatus: searchadsCampaign.servingStatus,
            appNamePrefix: `DEV-${appItem.user.shortId}-${appItem.appId}`
          }
        }));
  
        const discoveryMap = await Promise.all(appItem.discoveryByRegion.map( async(item) => {
          // console.log('campaignMapForAppId', campaignMapForAppId)
          let reportResponse, totalData;
          if ( item.campaignId ){
            try {
              reportResponse = await axios.get(`${API_URL}/user/campaigns/cid/${item.campaignId}/adgroups/rowtotals/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`, { headers } )
              if ( reportResponse.data.response.pagination.totalResults  > 0 ) {
                totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
              }
              console.log( '[campaigns adgroups] ', item.campaignId,  reportResponse.data); 
            } catch (error) {
              console.log( '[campaigns adgroups] ', item.campaignId, error); 
            }
          }
          return {
            appId: appItem.appId, //primary id
            region: item.region,
            dCid: item.campaignId,
            dReportAdGroup: reportResponse.data.response,
            dTotalData: totalData,
  
            smAdGroupId: item.smAdGroupId,
            bmAdGroupId: item.bmAdGroupId,
            storeInfo: storeInfo
          }
        }));
  
        let campaignMapForAppId = _.map(performanceMap, obj => {
            return _.assign(obj, _.find(discoveryMap, {
                appId: obj.appId,
                region: obj.region
            }));
        });
  
  
        
        
  
        globalCampaignList =  _.unionBy(this.state.globalCampaignList, campaignMapForAppId);
        console.log('globalCampaignList  : ', globalCampaignList);
        
        this.setState({
          globalCampaignList
        });
      }));

     
    }

  }
  
  componentWillUpdate(){
    console.log( ' componentWillUpdate')
    //check difference
    
  }
  componentWillReceiveProps(){
    console.log( ' componentWillReceiveProps')
    
  }

  goTo(route) {
    this.props.history.push(`${route}`)
  }

  render() {
    const { profile, globalCampaignList } = this.state;
    console.log ( "globalCampaignList render " +  globalCampaignList)
    console.log( "props in render " + this.props)
    const { appDetail } = this.state;
    const { searchTerm, campaign} = this.props;    
    const { rowStyle, colStyle } = basicStyle;


    const { app1 , app2} = this.state;    
    const currentApp = app1;
    const secondApp = app2;
    let content = (<div></div>);
    // If we have budgetSplit, render them
    
    if (globalCampaignList) {
      //console.table(globalCampaignList);
      content = (
        <div></div>
//         <div className="campaign-list">
//           <ul>
//           {
//             globalCampaignList.map((item) => {
//               console.log( 'campaign in render ' , item)
//               const storeInfo = item.storeInfo;
//               const dTotalData = item.dTotalData;
//               const pTotalData = item.pTotalData;
//               return (
//                 <div>
//               <li>
//               <Link key={ item.appId} to={`/dashboard/${item.appId}/region/${item.region}/pcid/${item.pCid}/dcid/${item.dCid}` }>
//               <dl className="app-header">
//                 <dt>
//                   <img src={ storeInfo && storeInfo.artworkUrl100} alt="screen"/>
//                 </dt>

//                 <dd>
//                   <span className="app-name">{ storeInfo && storeInfo.trackCensoredName }</span>
//                   <span className="app-desc">{ 'Region : ' + item.region + ' ' + item.appNamePrefix}</span>
//                   <span className="app-desc">{ 'p cid : ' + item.pCid }</span>
//                   <span className="app-desc">{ 'd cid : ' + item.dCid }</span>
//                   <span className="app-desc">{ storeInfo && storeInfo.sellerName }</span>
//                 </dd>
//               </dl>
//               </Link>
//               <dl className="cost">
//                 <dt>Cost Per Acquisition</dt>
//                 <dd>
//                   P: ${ pTotalData ? pTotalData.total.avgCPA.amount : ' --- '}
//                   <img src={ RedUpArrow } className="arrow-up"/>
//                 </dd>
//                 <dd>
//                   D:${ pTotalData ? pTotalData.total.avgCPA.amount : ' --- '}
//                   <img src={ RedUpArrow } className="arrow-up"/>
//                 </dd>
//               </dl>

//               <dl className="rate">
//                 <dt>Conversion Rate</dt>
//                 <dd>
//                   { pTotalData ? pTotalData.total.conversionRate * 100 + '%' : ' --- '}
//                   <div></div>
//                 </dd>
//                 <dd>
//                   { dTotalData ? dTotalData.total.conversionRate * 100 + '%' : ' --- '}
//                   <div></div>
//                 </dd>
//               </dl>

//               <div className="status"  >
//                 <input type="checkbox" 
//                   checked={item.servingStatus === 'RUNNING' ? true : false } 
//                   id={item.pCid + ' ' + item.dCid} 
//                   onChange={(event) => this.onStatusChanged(item.pCid, item.dCid,  event.target.checked? 'ENABLED' : 'PAUSED')}
//                   />
//                 <label htmlFor={item.pCid + ' ' + item.dCid} className="switch-wrapper">
//                   <span>
//                     <img src={ RunningIcon } className="running"/>
//                     <img src={ PauseIcon } className="paused"/>
//                   </span>

//                   <p className="running"></p>
//                   <p className="paused"></p>
//                 </label>
//               </div>
//             </li>
//             <ReactJson src={item} collapsed={ false}/>

// </div>
//             )
//               }
//             )
//           }
//           </ul>
//         </div>

      );

      

    } 


    /**
     * for fake
     */
    if ( process.env.REACT_APP_STAGE === 'fake' ){
      content =  (
        <div className="campaign-list">
        <ul>
          <li>
            <Link key={ currentApp.adamId} to={`/dashboard/${currentApp.adamId}`}>
            <dl className="app-header">
              <dt>
                <img src={ currentApp.artworkUrl100} alt="screen"/>
              </dt>

              <dd>
                <span className="app-name">{ currentApp.trackCensoredName }</span>
                <span className="app-desc">{ currentApp.sellerName }</span>
              </dd>
            </dl>
            </Link>
            <dl className="cost">
              <dt>Cost Per Acquisition</dt>
              <dd>
                $1.71
                <img src={ RedUpArrow } className="arrow-up"/>
              </dd>
            </dl>

            <dl className="rate">
              <dt>Conversion Rate</dt>
              <dd>
                67.21%
                <div></div>
              </dd>
            </dl>

            <div className="status">
              <input type="checkbox" id="test1"/>
              <label htmlFor="test1" className="switch-wrapper">
                <span>
                  <img src={ RunningIcon } className="running" />
                  <img src={ PauseIcon } className="paused" />
                </span>

                <p className="running"></p>
                <p className="paused"></p>
              </label>
            </div>
          </li>
          
          <li>
          <Link key={ secondApp.adamId} to={`/dashboard/${secondApp.adamId}`}>

            <dl className="app-header">
              <dt>
                <img src={ secondApp.artworkUrl100} alt="screen"/>
              </dt>

              <dd>
                <span className="app-name">{ secondApp.trackCensoredName }</span>
                <span className="app-desc">{ secondApp.sellerName }</span>
              </dd>
            </dl>
            </Link>

            <dl className="cost">
              <dt>Cost Per Acquisition</dt>
              <dd>
                $0.87
                <img src={ GreenDownArrow }/>
              </dd>
            </dl>

            <dl className="rate">
              <dt>Conversion Rate</dt>
              <dd>
                72.60%
                <div></div>
              </dd>
            </dl>

            <div className="status">
              <input type="checkbox" id="test2"/>
              <label htmlFor="test2" className="switch-wrapper">
                <span>
                  <img src={ RunningIcon } className="running" />
                  <img src={ PauseIcon } className="paused" />
                </span>

                <p className="running"></p>
                <p className="paused"></p>
              </label>
            </div>
          </li>
        </ul>
      </div>
      );

    }
    
    

    return (
      <CampaignListWrapper className="page-wrapper">
        <Header>
          <div className="header-row">
            <HeaderLogo isClickable={true} history={this.props.history} />
            <HeaderMenu history={this.props.history} auth={this.props.auth}/>
          </div>

          <div className="header-row">
            <h1>广告项目列表</h1>
            
            <HeaderFillRow className="hidden-xs"/>
            <SearchApp
              auth={this.props.auth}
              goTo={this.goTo.bind(this)}
              selectClassName="two-lines-result"
              value={this.state.value}
              onChange={this.onChange}
              backspaceRemoves={this.state.backspaceRemoves}
              placeholder="搜索你的应用名称或App ID"
            />
          </div>
        </Header>

        <div className="campaign-list">
          <CampaignsHolder
            authHeader={`Bearer ${ this.props.auth.getAccessToken() }`}
          />
        </div>

        { content }

        {/* <div className="account-menu">
          <ul>
            <li>
              <a href="account" className="active">My Account</a>
            </li>
            
            <li>
              <a href="billing">Billing</a>
            </li>
          </ul>
        </div> */}

          <div className="profile-area">
          {/* <h1>{ profile ? profile.name : ''}</h1>
          <Panel header="Profile">
            <img src={ profile ?  profile.picture : ''} alt="profile" />
            <div>
              <ControlLabel><Glyphicon glyph="user" /> Nickname</ControlLabel>
              <h3>{ profile ?  profile.nickname : ''}</h3>
            </div>
            <pre>{JSON.stringify(profile, null, 2)}</pre>
          </Panel> */}

          {/* <Panel header="Campaign">
            <div>
             { content }
            </div>
          </Panel> */}
        </div>

        <Footer/>
      </CampaignListWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}
function mapStateToProps(state) {
  const campaign  = state.get('deep').campaign;
  return { 
    search: state.get('search'),
    campaign: campaign,
    currentApp: state.getIn( ['App', 'currentApp']),
    secondApp: state.getIn( ['App', 'secondApp']),
    searchTerm: state.getIn( ['App', 'searchTerm']),
    countryCode: state.getIn( ['ItunesSearch', 'countryCode']) && 'US',

  }
}



export default  connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignList);



// WEBPACK FOOTER //
// ./src/containers/CampaignList/index.js